/**
 * Formats a number into Indian Rupee (INR) currency format.
 * Example: 165000 -> ₹1,65,000.00
 *
 * @param {number} amount The number to format.
 * @returns {string} The formatted currency string.
 */
function formatINR(amount) {
  if (typeof amount !== 'number' || isNaN(amount)) {
    return 'Invalid Amount';
  }

  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2, 
  }).format(amount);
}

const products = [
 
  {
    id: 1,
    name: "Fresh Farm Eggs (Dozen)",
    price: 250.00,
    description: "Fresh, organic eggs from free-range chickens. Pack of 12.",
    image: "https://images.unsplash.com/photo-1582722872445-44dc5f7e3c8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    category: "Fresh Eggs"
  },
  {
    id: 2,
    name: "Free-Range Brown Eggs",
    price: 320.00,
    description: "Brown eggs from happy, free-roaming hens. Pack of 12.",
    image: "https://images.unsplash.com/photo-1506976785307-8732e854ad03?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    category: "Fresh Eggs"
  },
  {
    id: 3,
    name: "Organic Omega-3 Eggs",
    price: 260.00,
    description: "Eggs rich in Omega-3 from hens fed with flaxseed. Pack of 12.",
    image: "https://goodeggs4.imgix.net/934cdcb5-e528-44fc-bc92-cad41d4d875b.jpg?w=840&h=525&fm=jpg&q=80&fit=crop",
    category: "Fresh Eggs"
  },

 
  {
    id: 4,
    name: "Crushed Egg Shell (500g)",
    price: 400.00,
    description: "Sterilized crushed egg shells, perfect for gardening and composting.",
    image: "https://rukminim2.flixcart.com/image/480/640/jy7kyvk0/soil-manure/f/v/m/5-eggshell-powder-faster-than-bone-meal-green-dews-original-imaff7hfefep9yqn.jpeg?q=90",
    category: "Egg Shell Products"
  },
  {
    id: 5,
    name: "Egg Shell Powder (250g)",
    price: 300.00,
    description: "Fine egg shell powder, rich in calcium. Ideal for supplements and crafts.",
    image: "https://images.immediate.co.uk/production/volatile/sites/10/2024/04/2048x1365-Eggs-shells-for-plants-SEO-GettyImages-1192171791-ce6050a.jpg",
    category: "Egg Shell Products"
  },

  
  {
    id: 6,
    name: "Liquid Egg Whites (32oz)",
    price: 450.00,
    description: "Pasteurized liquid egg whites, perfect for protein shakes and baking.",
    image: "https://i5.walmartimages.com/asr/b7c7825b-b0ac-4e21-a894-f7544c3b45ff_1.6c3ad55edfe7b1ac23ff49f04eebd332.jpeg",
    category: "Egg White Products"
  },
  {
    id: 7,
    name: "Egg White Powder (1lb)",
    price: 1300.00,
    description: "Dehydrated egg white powder. Great for baking and protein supplements.",
    image: "https://i5.walmartimages.com/seo/Eggylicious-Egg-White-Albumin-Powder-1lbs-16oz_4c534c2b-a148-4b27-a3e0-b8c3a0d88fde.fc965573db73c38ea2ff8bf84a08ac1a.jpeg",
    category: "Egg White Products"
  },

 
  {
    id: 8,
    name: "Liquid Egg Yolk (16oz)",
    price: 300.00,
    description: "Pure liquid egg yolks, rich in nutrients. Perfect for baking and sauces.",
    image: "https://tb-static.uber.com/prod/image-proc/processed_images/5fb96f604806f35cc137bf8b83e53f31/b4665c191b34baf3d0e0fa45dfdd3d1d.jpeg",
    category: "Egg Yolk Products"
  },
  {
    id: 9,
    name: "Egg Yolk Powder (250g)",
    price: 550.00,
    description: "Dehydrated egg yolk powder. Ideal for baking and nutritional supplements.",
    image: "https://5.imimg.com/data5/SELLER/Default/2025/3/494100858/GX/TM/QH/160164297/dry-egg-powder.jpg",
    category: "Egg Yolk Products"
  },

  
  {
    id: 10,
    name: "Whole Egg Powder (1lb)",
    price: 800.00,
    description: "Complete dehydrated whole eggs. Long shelf life, perfect for baking.",
    image: "https://5.imimg.com/data5/SELLER/Default/2025/9/541674462/ZM/MC/KQ/229479295/egg-white-powder-500x500.jpg",
    category: "Whole Egg Products"
  },

  
  {
    id: 11,
    name: "Quail Eggs (Pack of 20)",
    price: 150.00,
    description: "Delicate quail eggs, perfect for appetizers and gourmet dishes.",
    image: "https://m.media-amazon.com/images/I/91tpbtTqiTL._AC_UF1000,1000_QL80_.jpg",
    category: "Specialty Eggs"
  },
  {
    id: 12,
    name: "Duck Eggs (Half Dozen)",
    price: 180.00,
    description: "Rich and flavorful duck eggs, larger than chicken eggs.",
    image: "https://goodeggs4.imgix.net/5f910e7b-b355-465b-af4d-2c9e5b6c5141.jpg?w=840&h=525&fm=jpg&q=80&fit=crop",
    category: "Specialty Eggs"
  },


  {
    id: 13,
    name: "Hard-Boiled Eggs (6-pack)",
    price: 120.00,
    description: "Pre-cooked, peeled hard-boiled eggs. Ready to eat, perfect for snacks.",
    image: "https://images.albertsons-media.com/is/image/ABS/960307279-C1N1?$ng-ecom-pdp-desktop$&defaultImage=Not_Available",
    category: "Prepared Eggs"
  },
  {
    id: 14,
    name: "Deviled Eggs (6-piece)",
    price: 250.00,
    description: "Gourmet deviled eggs with classic filling. Perfect for parties.",
    image: "https://www.allrecipes.com/thmb/UNa8SlUqV7UpCJAOEsWe4ufCv2E=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/222589-simple-deviled-eggs-ddmfs-1382-4x3-dea80f9108f044af8a8e29c1664bfa13.jpg",
    category: "Prepared Eggs"
  },

 
  {
    id: 15,
    name: "Egg Wash (32oz)",
    price: 500.00,
    description: "Ready-to-use egg wash for baking. Gives pastries a golden finish.",
    image: "https://i2.wp.com/bakerbettie.com/wp-content/uploads/2020/08/egg-wash-2-1-720x720.jpg",
    category: "Bulk Products"
  },
  {
    id: 16,
    name: "Frozen Scrambled Eggs (2lb)",
    price: 700.00,
    description: "Pre-mixed and frozen scrambled eggs. Quick breakfast solution.",
    image: "https://foodexitrecipes.com/wp-content/uploads/2025/05/Chili-Scrambled-Eggs-13.jpg",
    category: "Bulk Products"
  },
  {
    id: 17,
    name: "Commercial Bulk: LCV Tempo Load of Fresh Eggs",
    price: 165000.00,
    description: "A full Light Commercial Vehicle (LCV) load of our standard fresh chicken eggs. This order includes approximately 700 crates (21,000 eggs), ideal for commercial kitchens, distributors, or large event caterers. Price includes basic local delivery and breakage insurance. Delivery outside local zones may incur additional, calculated shipping charges.",
    image: "https://5.imimg.com/data5/SELLER/Default/2021/10/YX/HD/VF/2252489/chota-hathi-500x500.jpg",
    category: "Bulk Products"
  }
];

const formattedProducts = products.map(product => ({
  ...product, 
  formattedPrice: formatINR(product.price), 
}));

export default formattedProducts;

